import { createContext, useContext, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { workspacesApi } from '../lib/api';
import { paths } from '../routes/paths';

const WorkspacesContext = createContext(null);

export function WorkspacesProvider({ children }) {
  const navigate = useNavigate();
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchWorkspaces = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const data = await workspacesApi.list(signal);
      setWorkspaces(Array.isArray(data) ? data : []);
    } catch (err) {
      if (err.name !== 'AbortError') setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchWorkspaces(controller.signal);
    return () => controller.abort();
  }, [fetchWorkspaces]);

  const createWorkspace = useCallback(async (name) => {
    const { id } = await workspacesApi.create({ name });
    // Atualiza imediatamente o estado global compartilhado por todos
    await fetchWorkspaces(); 
    return id;
  }, [fetchWorkspaces]);

  const joinWorkspace = useCallback((workspaceId) => {
    navigate(paths.workspace(workspaceId));
  }, [navigate]);

  return (
    <WorkspacesContext.Provider value={{
      workspaces,
      loading,
      error,
      refetch: fetchWorkspaces,
      createWorkspace,
      joinWorkspace
    }}>
      {children}
    </WorkspacesContext.Provider>
  );
}

export const useWorkspacesContext = () => useContext(WorkspacesContext);
